<script>
import Button from '../../common/Button'
import TableHeaderInput from '../table/TableHeaderInput'
// import Dropdown from '../Dropdown'
import ViewChange from '../ViewChange'
import { urlQueriesMixins } from '../../../utils/mixins'
import dadbanUsersProvider from '../../../services/dadban/user'
import dadbanOrderProvider from '../../../services/dadban/order'
import moocCourseProvider from '../../../services/mooc/course'
import readXlsxFile from 'read-excel-file'
import Toast from '../Toast.vue'
import axios from 'axios'
import { API_URL } from '../../../../config/HTTP'
import LicenseRequestModal from '../../mooc/courses/LicenseRequestModal.vue'
import skillUpCourseProvider from '../../../services/skillUp/course'
import skillUpPackageProvider from '../../../services/skillUp/package'
import PrintCertificatesModal from '../../skillup/issuanceOfCertificate/PrintCertificatesModal.vue'
import skillUpIssuanceCertificate from '../../../services/skillUp/issuanceOfACertificate'
export default {
  props: {
    objectList: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
    },
    text: {
      default: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفادهاز طراحان گرافیک است.',
      type: String,
    },
    titleVisible: {
      type: Boolean,
      default: false,
    },
    textVisible: {
      type: Boolean,
      default: false,
    },
    bottomTitle: {
      type: Boolean,
      default: false,
    },
    contextVisible: {
      type: Boolean,
      default: false,
    },
    searchVisible: {
      default: false,
      type: Boolean,
    },
    changeGrid: {
      default: false,
      type: Boolean,
    },
    button: {
      default: false,
      type: Boolean,
    },
    buttonTitle: {
      default: 'مشتری جدید',
      type: String,
    },
    buttonRoute: {
      type: String,
    },
    buttonFunction: {
      type: Function,
    },
    contextClass: {
      type: String,
      default: '',
    },
    actionClass: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
    },
    url: {
      type: String,
    },
    notDropdown: {
      type: Boolean,
      default: false,
    },
    settingBtn: {
      type: Boolean,
      default: false,
    },
    filterList: {
      type: Array,
    },
    getData: {
      type: Function,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Button,
    ViewChange,
    TableHeaderInput,
    Toast,
    LicenseRequestModal,
    PrintCertificatesModal,
  },
  mixins: [urlQueriesMixins],
  data() {
    return {
      searchedValue: '',
      showModal: false,
      requestLoading: false,
      userExcelOutputLoading: false,
      checkedField: null,
      headerFilters: [],
      customFilters: [],
      headerFields: [],
      mockFilter: [],
      searchFilter: [],
      timer: null,
      fastFilterRoutes: ['/list/courses', '/list/teachers', '/list/mentors', '/list/packages', '/list/discount', '/list/skillupdiscount', '/list/universityteachers'],
      toastError: false,
      toastText: '',
      showToast: false,
      loading: false,
      license: {
        type: 0,
        count: '',
      },
      lastIndex: undefined,
    }
  },
  methods: {
    getTeamTaskDataForTable() {
      if (this.exceptionsRoute) {
        setTimeout(() => {
          this.changeRoute()
        }, 500)
        return false
      }
      this.$store.dispatch('urlQueries/setCurrentPage', 1)
      const route = this.$route
      let teamTaskType = null
      const query = this.searchQuery
      const pageSize = this.pageSize
      let filters = this.filters
      let queryParams = null
      if (this.fastFilterRoutes.includes(route.path) && this.validSearchFilter !== null) {
        queryParams = {
          key: route.params.slug,
          query: query,
          filters: filters,
          fieldSearchs: [
            {
              fieldName: 'Status',
              text: this.validSearchFilter ? `${this.validSearchFilter}` : null,
            },
          ],
          pageNumber: 1,
          pageSize: pageSize,
        }
      } else if (
        [
          '/list/universitycourses',
          '/list/shortuniversitypackages',
          '/list/longuniversitypackages',
          '/list/skilluptotalcomments',
          '/list/skilluppackages',
          '/list/skillupcourses',
          '/list/facultyskillupcourses',
          '/list/facultyskilluppackages',
        ].includes(this.$route.path)
      ) {
        let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
        let pageSizes = route.query.perPage ? route.query.perPage : 10
        queryParams = {
          key: route.params.slug,
          query: query,
          filters: filters,
          pageNumber: pageNumber,
          pageSize: pageSizes,
          fieldSearchs:
            this.$route.path === '/list/skilluptotalcomments' && this.headerFilters.length < 1
              ? [{ fieldName: 'Status', text: '0' }]
              : this.headerFilters.map((f) => {
                  return {
                    fieldName: f.fieldName,
                    text: `${f.key}`,
                  }
                }),
        }
      } else if (this.$route.path === '/list/skillupdiscount/add' || this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id) {
        let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
        let pageSizes = route.query.perPage ? route.query.perPage : 10
        queryParams = {
          search: query,
          fieldSearchs: [
            {
              fieldName: 'ProductType',
              text: this.headerFilters.length > 1 || !this.headerFilters.length ? '-1' : `${this.headerFilters[0]}`,
            },
          ],
          pageNumber: pageNumber,
          pageSize: pageSizes,
        }
        setTimeout(() => {
          this.getData(queryParams)
          if (!this.$route.path === '/list/discount/add' && !this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
            this.changeRoute()
          }
        }, 500)
        return false
      } else if (route.name === 'mooc-issuance-certificate') {
        let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
        let pageSizes = route.query.perPage ? route.query.perPage : 10
        queryParams = {
          query,
          key: 'universitylicensepeople',
          fieldSearchs: [
            {
              fieldName: 'CourseId',
              type: 'string',
              text: route.params.courseId,
            },
          ],
          pageNumber: pageNumber,
          pageSize: pageSizes,
        }
        setTimeout(() => {
          this.getData(queryParams)
          if (!this.$route.path === '/list/discount/add' && !this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
            this.changeRoute()
          }
        }, 500)
        return false
      } else if (route.name === 'transactions-fromListsWallet' || route.name === 'transactions-fromUserManagement') {
        teamTaskType = ''
        queryParams = {
          key: teamTaskType,
          search: query,
          filters: filters,
          pageNumber: 1,
          pageSize: pageSize,
          fieldSearchs: [
            {
              fieldName: 'UserId',
              type: 'string',
              text: route.params.id,
            },
            {
              fieldName: 'Coin',
              type: 'string',
              text: route.params.slug,
            },
          ],
        }
        setTimeout(() => {
          this.getData(queryParams)
          if (!this.$route.path === '/list/discount/add' && !this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
            this.changeRoute()
          }
        }, 500)
        return false
      } else {
        teamTaskType = route.params.slug
        queryParams = {
          key: teamTaskType,
          query: query,
          filters: filters,
          pageNumber: 1,
          pageSize: pageSize,
        }
        setTimeout(() => {
          this.getData(queryParams)
          if (!this.$route.path === '/list/discount/add' && !this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
            this.changeRoute()
          }
        }, 500)
        return false
      }
      setTimeout(() => {
        this.getData(queryParams)
        if (!this.$route.path === '/list/discount/add' && !this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
          this.changeRoute()
        }
      }, 500)
    },
    changeRoute() {
      const query = this.searchQuery
      let pageNumber = this.currentPage.toString()
      let perPage = this.pageSize.toString()
      let filters = this.filters ? this.filters : ''
      let queries = [{ pageNumber: pageNumber }, { query: query }, { filters: filters }, { perPage: perPage }]
      const thisRoute = this.$route.path
      let queryKey = []
      let queryValue = []
      for (let i = 0; i < queries.length; i++) {
        if (Object.entries(queries[i])[0][1].length > 0) {
          queryKey.push(Object.entries(queries[i])[0][0])
          queryValue.push(Object.entries(queries[i])[0][1])
        }
      }
      let queryObject = {}
      for (let i = 0; i < queryKey.length; i++) {
        queryObject[queryKey[i]] = queryValue[i]
      }
      this.$router.push({ path: thisRoute, query: queryObject })
    },
    GridView() {
      this.$router.push({ path: '/teamtask-board' })
    },
    doFilter(field, index) {
      const textField = this.$refs.textField
      this.filters ? (this.headerFilters = this.filters) : ''
      textField[index].classList.toggle('active')

      if (this.fastFilterRoutes.includes(this.$route.path)) {
        if (this.searchFilter.includes(field.key)) {
          const fil = this.searchFilter.findIndex((item) => item === field.key)
          this.searchFilter.splice(fil, 1)
        } else {
          this.searchFilter.pop()
          this.searchFilter.push(field.key)
          textField[this.lastIndex]?.classList.remove('active')
          this.lastIndex = index
        }
      } else if (textField[index].classList.contains('active')) {
        if (
          [
            '/list/universitycourses',
            '/list/shortuniversitypackages',
            '/list/longuniversitypackages',
            '/list/skilluptotalcomments',
            '/list/skilluppackages',
            '/list/skillupcourses',
            '/list/facultyskillupcourses',
            '/list/facultyskilluppackages',
          ].includes(this.$route.path)
        ) {
          this.headerFilters.pop()
          this.headerFilters.push(field)
          textField[this.lastIndex]?.classList.remove('active')
          this.lastIndex = index
        } else {
          this.headerFilters.pop()
          this.headerFilters.push(field.key)
          textField[this.lastIndex]?.classList.remove('active')
          this.lastIndex = index
        }
      } else {
        if (
          [
            '/list/universitycourses',
            '/list/shortuniversitypackages',
            '/list/longuniversitypackages',
            '/list/skilluptotalcomments',
            '/list/skilluppackages',
            '/list/skillupcourses',
            '/list/facultyskillupcourses',
            '/list/facultyskilluppackages',
          ].includes(this.$route.path)
        ) {
          let finded = this.headerFilters.find((a) => a.key == field.key)

          this.headerFilters = this.headerFilters.filter((a) => a != finded)
        } else {
          let finded = this.headerFilters.find((a) => a == field.key)
          this.headerFilters = this.headerFilters.filter((a) => a != finded)
        }
      }

      this.$store.dispatch('urlQueries/setFields', this.headerFilters)

      this.getTeamTaskDataForTable()
    },
    searchOnKeyUp($event) {
      if ($event) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.getTeamTaskDataForTable()
        }, 300)
      }
    },
    openUploadBox() {
      this.$refs.inputFile.click()
    },
    async downloadUserListExcel() {
      this.userExcelOutputLoading = true
      axios({
        url: 'https://apg.cloudware.ir/People/api/People/PeopleListDownload',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'اکسل لیست کاربران.xlsx')
        document.body.appendChild(link)
        link.click()
        this.userExcelOutputLoading = false
      })
    },
    async uploadValidatedExcel(data) {
      const formData = new FormData()
      formData.append('file', data)
      try {
        this.loading = true
        const req = await dadbanUsersProvider.addUsersExcel(this.$route.params.courseId || this.$route.params.packageId, this.$route.params.courseId ? 0 : 1, formData)
        this.$emit('update')
        const message = req.data.data.output
        if (req.status === 200) {
          this.toastText = `تعداد ${message.newPeople} اضافه شد و تعداد ${message.duplicatePeople} کاربر تکراری بود`
          this.showToast = true
          this.loading = false
          setTimeout(() => {
            this.showToast = false
            this.toastError = false
            this.$refs.inputFile.value = ''
          }, 5000)
          return false
        }
      } catch (error) {
        this.toastText = error.response.data.message
        this.toastError = true
        this.loading = false
        this.showToast = true
      }
      setTimeout(() => {
        this.showToast = false
        this.toastError = false
        this.$refs.inputFile.value = ''
      }, 5000)
    },

    uploadExcel(event) {
      const blob = event.target.files[0]
      const lengthError = 'ادمین گرامی امکان اضافه کردن بیش از 500 کاربر وجود ندارد.'
      const checkDataError = 'ادمین گرامی لطفا طبق فایل نمونه اقدام به بارگزاری فایل اکسل نمایید.'
      let shouldUpload = true

      readXlsxFile(blob).then((rows) => {
        if (rows.length > 500) {
          this.toastError = true
          this.toastText = lengthError
          this.showToast = true
          shouldUpload = false
          return
        }

        if (rows[0][0] !== 'نام' || rows[0][1] !== 'نام خانوادگی' || rows[0][2] !== 'کدملی' || rows[0][3] !== 'شماره تلفن') {
          this.toastError = true
          this.toastText = checkDataError
          this.showToast = true
          shouldUpload = false
          return
        }

        rows.forEach((row, index) => {
          if (rows[index]?.length !== 4) {
            this.toastError = true
            this.toastText = checkDataError
            this.showToast = true
            shouldUpload = false
            return
          }

          if (index > 0) {
            row.forEach((r, idx) => {
              if ([0, 1].includes(idx)) {
                if (!row[idx]?.length) {
                  this.toastError = true
                  this.toastText = checkDataError
                  this.showToast = true
                  shouldUpload = false
                  return
                }
              }
              if (idx === 3) {
                if (!row[idx]?.length || !row[idx].match(/^0?9[0-9]{9}$/)) {
                  this.toastError = true
                  this.toastText = checkDataError
                  this.showToast = true
                  shouldUpload = false
                  return
                }
              }
            })
          }
        })

        if (shouldUpload) {
          this.uploadValidatedExcel(blob)
        }
      })
    },
    uploadActivityOrderExcel(event) {
      const blob = event.target.files[0]

      readXlsxFile(blob).then((rows) => {
        this.uploadActivityOrderValidatedExcel(blob)
      })

      setTimeout(() => {
        this.showToast = false
      }, 5000)
    },
    async uploadActivityOrderValidatedExcel(data) {
      const formData = new FormData()
      formData.append('file', data)
      try {
        this.loading = true
        const req = await skillUpPackageProvider.uploadActivityOrder(formData, this.$route.params.packageId)
        this.$emit('update')
        const message = req.data.data.output
        if (req.status === 200 && req.data.data.isSuccessful) {
          this.toastText = 'بارگزاری با موفقیت ثبت شد.'
          this.showToast = true
          this.loading = false
          setTimeout(() => {
            this.showToast = false
            this.toastError = false
            this.$refs.inputFile.value = ''
          }, 5000)
          return false
        } else {
          this.toastText = req.data.data.output.message
          this.toastError = true
          this.loading = false
          this.showToast = true
        }
      } catch (error) {
        this.toastText = error.response.data.message
        this.toastError = true
        this.loading = false
        this.showToast = true
      }
      setTimeout(() => {
        this.showToast = false
        this.toastError = false
        this.$refs.inputFile.value = ''
      }, 5000)
    },
    async downloadSampleExcel(fileName, file, fileType) {
      const blobFile = new Blob([file], { fileType })
      const url = URL.createObjectURL(blobFile)

      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)

      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      )

      URL.revokeObjectURL(url)
      document.body.removeChild(link)
    },
    async downloadExcelHandle() {
      window.open('https://dl.cloudware.ir/dl/نمونه لیست اعضا.xlsx', '_blank')
    },
    async exportExcel() {
      axios({
        url: API_URL + '/academy/api/Basket/Download',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'لیست سفارشات.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    async requestCertificate() {
      if (this.$route.params.courseId) {
        try {
          this.requestLoading = true
          const req = await skillUpCourseProvider.userLicenseRequest({
            courseId: +this.$route.params.courseId,
          })
          if (req.status === 200) {
            if (req.data.data.output.error == 2 || req.data.data.output.error == 3) {
              this.license.count = req.data.data.output.message
              this.license.type = req.data.data.output.error
              this.$bvModal.show('licenseRequest')
            } else if (req.data.data.output.error == 1) {
              this.toastText = 'درخواست صدور مدرک قبلا ارسال شده است.'
              this.toastError = true
              this.showToast = true
              setTimeout(() => {
                this.showToast = false
                this.toastError = false
                this.toastText = ''
              }, 5000)
            } else if (req.data.data.output.error == 0) {
              this.toastText = 'درخواست صدور مدرک با موفقیت ارسال شد.'
              this.showToast = true
              setTimeout(() => {
                this.showToast = false
                this.toastText = ''
              }, 5000)
            }
          }
          this.requestLoading = false
        } catch (error) {
          this.requestLoading = false
        }
      } else {
        try {
          this.requestLoading = true
          const req = await skillUpPackageProvider.userLicenseRequest({
            packageId: +this.$route.params.packageId,
          })
          if (req.status === 200) {
            if (req.data.data.output.error == 2 || req.data.data.output.error == 3) {
              this.license.count = req.data.data.output.message
              this.license.type = req.data.data.output.error
              this.$bvModal.show('licenseRequest')
            } else if (req.data.data.output.error == 1) {
              this.toastText = 'درخواست صدور مدرک قبلا ارسال شده است.'
              this.toastError = true
              this.showToast = true
              setTimeout(() => {
                this.showToast = false
                this.toastError = false
                this.toastText = ''
              }, 5000)
            } else if (req.data.data.output.error == 0) {
              this.toastText = 'درخواست صدور مدرک با موفقیت ارسال شد.'
              this.showToast = true
              setTimeout(() => {
                this.showToast = false
                this.toastText = ''
              }, 5000)
            }
          }
          this.requestLoading = false
          console.log(req)
        } catch (error) {
          this.requestLoading = false
        }
      }
    },
    async checkHasLicense() {
      const req = await skillUpIssuanceCertificate.hasLicense({
        id: this.$route.params.courseId,
      })
      if (req.status === 200) {
        const payload = {
          peopleId: undefined,
          hasLicense: req.data.data.output,
        }
        window.localStorage.setItem('checkHasLicense', JSON.stringify(payload))
      }
    },

    requestIssuanceOfACertificate() {
      if (this.$route.name === 'mooc-issuance-certificate') this.$bvModal.show('certificateModal')
      else this.$bvModal.show('skillUpCertificateModal')
      this.checkHasLicense()
    },
  },
  computed: {
    exceptionsRoute() {
      if (this.$route.name === 'courses-package') {
        return true
      }
      if (this.$route.name === 'course-prerequisites') {
        return true
      }
      if (this.$route.name === 'package-prerequisites') {
        return true
      }
      if (this.$route.name === 'courses-package-activities') {
        return true
      }
      if (this.$route.name === 'courses-package-course-activities') {
        return true
      }
      if (this.$route.name.startsWith('comments')) {
        return true
      }
      return false
    },
    routeParam() {
      return this.$route.params.slug
    },
    validSearchFilter() {
      if (this.searchFilter.length === 1) {
        return +this.searchFilter[0]
      }
      if (this.searchFilter.length > 1) {
        return null
      }
      return null
    },
    cantEdit() {
      return (
        (this.$route.path.includes('faculty') || this.$route.path.includes('support') || this.$route.path.includes('agent')) &&
        (localStorage.getItem('productStatus') == 4 || localStorage.getItem('productStatus') == 3)
      )
    },
  },
  watch: {
    routeParam(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$store.dispatch('urlQueries/setSearchQuery', '')
        this.$store.dispatch('urlQueries/setCurrentPage', 1)
        this.$store.dispatch('urlQueries/setFields', [])
        this.$router.push({ path: newValue }).catch(() => {})
      }
    },
  },
  mounted() {
    this.headerFields = this.filterList

    if (this.fastFilterRoutes.includes(this.$route.path)) {
      this.headerFields = [
        { key: 1, label: 'فعال' },
        { key: 0, label: 'غیرفعال' },
      ]
      this.mockFilter = this.headerFields
    }
    if (
      [
        '/list/universitycourses',
        '/list/shortuniversitypackages',
        '/list/longuniversitypackages',
        '/list/skilluppackages',
        '/list/skillupcourses',
        '/list/facultyskillupcourses',
        '/list/facultyskilluppackages',
      ].includes(this.$route.path)
    ) {
      this.headerFields = [
        { key: 0, label: 'پیش نویس', fieldName: 'LicenseStatus' },
        { key: 1, label: 'منتظر تایید', fieldName: 'LicenseStatus' },
        { key: 3, label: 'رد شده', fieldName: 'LicenseStatus' },
        { key: 4, label: 'تایید شده', fieldName: 'LicenseStatus' },
        { key: 2, label: 'نیاز به اصلاح', fieldName: 'LicenseStatus' },
      ]
      this.mockFilter = this.headerFields
    }
    if (['/list/skilluppackages', '/list/skillupcourses', '/list/facultyskillupcourses', '/list/facultyskilluppackages'].includes(this.$route.path)) {
      this.headerFields.push({ key: 1, label: 'فعال', fieldName: 'Status' }, { key: 0, label: 'غیرفعال', fieldName: 'Status' })
    }
    if (this.$route.path === '/list/skilluptotalcomments') {
      this.headerFields = [
        { key: 1, label: 'در انتظار', fieldName: 'Status' },
        { key: 2, label: 'تایید شده', fieldName: 'Status' },
        { key: 3, label: 'رد شده', fieldName: 'Status' },
      ]
      this.mockFilter = this.headerFields
    }
    if (this.$route.path === '/list/skillupdiscount/add' || this.$route.path === '/list/skillupdiscount/detail/' + this.$route.params.id) {
      this.headerFields = [
        { key: 0, label: 'دوره' },
        { key: 1, label: 'بسته' },
      ]
      this.mockFilter = this.headerFields
    }
    setTimeout(() => {
      const textField = this.$refs.textField
      if (this.filters) {
        for (let i = 0; i < this.filters.length; i++) {
          textField.find((f) => f.id == this.filters[i]).classList.add('active')
        }
      }
    }, 500)
  },
  destroyed() {},
}
</script>

<template>
  <div class="table-header mb-4">
    <div v-if="contextVisible" class="context mb-4" :class="contextClass">
      <h3 v-if="titleVisible">{{ title }}</h3>
      <h5 v-if="textVisible">{{ text }}</h5>
    </div>

    <div class="actions" :class="actionClass">
      <div v-if="bottomTitle">
        <h3>
          {{ title }}
        </h3>
      </div>

      <div v-if="searchVisible" class="d-flex align-items-center">
        <TableHeaderInput v-model="searchedValue" @onKeyUp="searchOnKeyUp($event)" :list="list" @focused="$emit('focused')" @update="$emit('update')" />
        <input v-if="$route.name === 'course-users' && !this.$route.path.includes('university')" type="file" ref="inputFile" @change="uploadExcel" class="excel-input" />
        <div v-if="$route.name === 'courses-package-activities'" class="upload-excel">
          <Button icon="fa-thin fa-file-excel" :loading="loading" class="mx-2" @click.native="openUploadBox" hasIcon text="بارگذاری فایل اکسل" btnClass="upload-btn btn-border" />
        </div>
        <input v-if="$route.name === 'courses-package-activities'" type="file" ref="inputFile" @change="uploadActivityOrderExcel" class="excel-input" />
        <div
          v-if="[`/list/skillupcourses/${$route.params.courseId}/users`, `/list/skilluppackages/${$route.params.packageId}/users/`].includes($route.fullPath)"
          class="upload-excel d-flex align-items-center"
        >
          <Button :loading="requestLoading" class="mx-2" @click.native="requestCertificate" text="درخواست صدور مدرک" btnClass="upload-btn btn-border" />

          <div @click="downloadExcelHandle">
            <b-button variant="outline-primary">فایل نمونه</b-button>
          </div>

          <Button :loading="loading" class="mx-2" @click.native="openUploadBox" text="بارگذاری فایل اکسل" btnClass="upload-btn btn-border" />
        </div>

        <div v-if="$route.name === 'courses-package'" class="upload-excel d-flex align-items-center">
          <b-button @click="$router.push(`${$route.path}/activities`)" variant="outline-primary">پیش نمایش الویت ها</b-button>
        </div>

        <div class="upload-excel" v-if="$route.fullPath === '/list/orders' || $route.fullPath === '/list/skilluporders'">
          <Button icon="fa-thin fa-file-excel" :loading="loading" class="mx-2" @click.native="exportExcel" hasIcon text="خروجی اکسل تجمیعی" btnClass="upload-btn btn-border" />
        </div>

        <div
          v-if="($route.name === 'mooc-issuance-certificate' && $route.fullPath.includes('/list/universitylicense/detail')) || $route.name === 'skillUp-issuance-certificate'"
          class="upload-excel"
        >
          <Button @click.native="requestIssuanceOfACertificate" text="چاپ مدرک همه" btnClass="upload-btn btn-border" />
        </div>

        <div v-if="(notDropdown && headerFields) != null" class="sorts">
          <div class="sortList d-flex align-items-center">
            <span>فیلتر سریع : </span>
            <div v-for="(field, index) in filterList || mockFilter" :key="field.key" @click="doFilter(field, index)">
              <div class="textField" ref="textField" :id="field.key">
                {{ field.label }}
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="notDropdown && headerFields == null" class="sorts"></div>
        <div v-else></div>
      </div>
      <div class="button">
        <div v-if="button" class="d-flex flex-row-reverse">
          <div class="header_btn d-flex align-items-center gap-2 flex-wrap">
            <div>
              <b-button :disabled="userExcelOutputLoading" v-if="$route.path === '/list/users'" class="user_excel_output" @click="downloadUserListExcel">
                <div class="d-flex gap-2 align-items-center">
                  <p style="margin: 0">خروجی اکسل کاربران</p>
                  <i v-if="userExcelOutputLoading" class="fa fa-spinner fa-spin"></i>
                </div>
              </b-button>
            </div>

            <div v-if="!$route.path.includes('/list/skilluptotalcomments') && !cantEdit" @click="buttonFunction">
              <Button hasIcon :text="buttonTitle" />
            </div>
          </div>
          <Button v-if="settingBtn" text="تنظیمات پیگیری" btnClass="mx-2 btn-outline-primary btn-approve-outline" @click.native="$emit('invitaionSetting', true)" />
          <Button v-if="settingBtn" text="لیست سیاه" btnClass="mx-2 btn-outline-primary btn-approve-outline" @click.native="$emit('blackList', true)" />
        </div>
        <div v-if="changeGrid && $route.params.slug !== 'Authentication-1'" class="changeGridSpan">
          <span class="me-2"> نمایش: </span>
          <ViewChange :isActive="isActive" :url="url" />
        </div>
      </div>
    </div>
    <Toast :error="toastError" :title="toastText" :showToast="showToast" />
    <LicenseRequestModal v-bind="license" />
    <PrintCertificatesModal v-bind="license" />
  </div>
</template>

<style scoped lang="scss">
.changeGridSpan {
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    font-family: IRANSansWeb(FaNum);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: left;
  }
}
.context {
  font-style: normal;
  font-weight: normal;
}
h5 {
  font-size: 15px;
  line-height: 25px;
  color: #999999;
}
h3 {
  font-size: 16px;
  line-height: 26px;
  text-transform: uppercase;
  color: #444444;
  margin: 0;
}
.sorts {
  margin-right: 110px;
}

.actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}
.sortList > .textField {
  // margin: 0 10px;
  cursor: pointer;
}
.textField {
  cursor: pointer;
  margin-right: 22px;
}
.sortList {
  span {
    color: #555555 !important;
  }
  .textField {
    color: #b7b4b4;
  }
}
.textField.active {
  background-color: #556be6;
  color: #fff;
  padding: 6px 20px;
  border-radius: 30px;
  margin-right: 10px;
}
::v-deep .button {
  button {
    padding: 8.5px 34px;
  }
}
.btn-outline-secondary {
  outline: 0 !important;
  box-shadow: none !important;
}
::v-deep .btn-approve-outline {
  background-color: white !important;
  span {
    color: #556be6 !important;
  }
}
::v-deep .btn-approve-outline:hover {
  background-color: #556be6 !important;
  span {
    color: #fff !important;
  }
}

.upload-excel {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
}

.excel-input {
  width: 0;
  height: 0;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
.user_excel_output {
  padding: 0.5rem !important;
  border-color: rgba(52, 195, 143, 1);
  background-color: rgba(52, 195, 143, 0.35);
  color: rgba(52, 195, 143, 1) !important;
  margin: 0.2rem 1rem;
  border-radius: 35px;
}

.user_excel_output:active,
:focus-visible {
  background-color: rgba(52, 195, 143, 0.35) !important;
  border-color: rgba(52, 195, 143, 1);
}

::v-deep .btn:first-child:active {
  background-color: rgba(52, 195, 143, 0.35) !important;
  border-color: rgba(52, 195, 143, 1) !important;
}

::v-deep .btn:first-child:focus-visible {
  background-color: rgba(52, 195, 143, 0.35) !important;
  border-color: rgba(52, 195, 143, 1) !important;
}

.user_excel_output:focus {
  box-shadow: none;
}

@media (min-width: 100px) {
  .header_btn button {
    padding: 7.52px 12px;
  }
}

@media (min-width: 281px) {
  .header_btn button {
    padding: 8.5px 34px;
  }
}
</style>
